<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "App",
  created () {
    if (sessionStorage.getItem("identification")) {
      if (this.$store.state.identification != sessionStorage.getItem("identification")) {
        sessionStorage.clear()
        sessionStorage.identification = this.$store.state.identification;
      }
    } else {
      sessionStorage.identification = this.$store.state.identification;
    }

    let state = sessionStorage.getItem("serverImage");
    //如果空跳转首页
    if (!state) {
      // sessionStorage.clear()
      this.$router.push({
        path: "/",
      })
    } else {
      state = JSON.parse(state);
      this.$store.state.serverImages = state;
    }
    window.bannerNavClick = this.bannerNavClick;

    this.init();


    // icon替换
    var link = document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = this.$store.state.serverImages.logoImage;
    document.getElementsByTagName("head")[0].appendChild(link);
    // 标题替换
    document.title = this.$store.state.serverImages.logoText || ''
    this.$store.state.title = this.$store.state.serverImages.logoText
    this.$store.state.videoTitle = this.$store.state.serverImages.logoText
    // 唯一标识缩写替换
    this.$store.state.projectName = this.$store.state.serverImages.abbreviation
    this.$store.state.identification = this.$store.state.serverImages.abbreviation
    // 二维码是否展示替换
    this.$store.state.needWeChatCode = this.$store.state.serverImages.wxImages == '' ? false : true
    this.$store.state.needAppCode = this.$store.state.serverImages.appImages == '' ? false : true
    // 一张图坐标替换
    if (this.$store.state.serverImages.aPictureCoordinate !== '') { this.$store.state.initExtent = this.$store.state.serverImages.aPictureCoordinate.split(",").map(Number); }
    // 登录按钮显示
    if (JSON.parse(sessionStorage.getItem('menuItemData')) !== null) {
      this.$store.state.isshowloginbtn = JSON.parse(sessionStorage.getItem('menuItemData'))[0].remark == 'true'
    }
  },
  methods: {
    filterLabel (data) {
      if (data !== '') {
        return data.split('</p>')[0].split('>')[1]
      } else {
        return ''
      }

    },
    init () {
      this.axios({
        method: "post",
        url: this.$store.state.Url7 + "TCityRegionRef/queryTCityRegionRef",
        data: {
          soId: this.$store.state.Soid
        }
      })
        .then(data => {
          this.$store.state.weatherLocation = data.data.data.cid;
        })
        .catch(err => {
          console.log(err);
        });

      this.axios({
        method: "post",
        url: this.$store.state.Url4 + "panorama/getAllPanoramasBySoId",
        data: {
          soId: this.$store.state.Soid
        }
      })
        .then(data => {
          this.$store.state.virtualSrc = data.data.data[0].url;
          sessionStorage.virtualSrc = data.data.data[0].url;
        })
        .catch(err => {
          console.log(err);
        });
    },
    bannerNavClick (currentRole, key) {
      $(".header_nav li").removeClass("active");
      this.$router.push({ path: currentRole, query: { value: key } });
      $(".banner_nav .banner_nav_container span").removeClass("active");
      $(".banner_nav_B .banner_nav_container span").removeClass("active");
      $(".bannerNavContainer" + key).addClass("active");

      if (key == "VirtualExperience") {
        $(".banner_nav").hide();
        $(".footer").hide();
      } else {
        $(".banner_nav").show();
        $(".footer").show();
      }
    }
  }
};
</script>

<style>
html,
body,
#app {
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
.content {
  min-height: 240px;
  background: #f5f5f5;
  padding: 20px 20% 20px 20%;
  text-align: center;
}
.container-water-fall {
  min-height: 240px;
}
.el-loading-spinner .path,
.el-loading-text {
  color: #08961f !important;
  stroke: #08961f !important;
}

.header_box {
  position: relative;
  width: 100%;
  z-index: 111;
  display: block;
}

@media only screen and (max-width: 1500px) {
  .content {
    padding: 20px 10% 20px 10%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue